<template>
  <table class="action-prop-table">
    <tr>
      <th>pending id</th>
      <td>{{action.pendingId}}</td>
    </tr>
    <tr>
      <th>product</th>
      <td>{{action.productId | getProtoAlias}}</td>
    </tr>
    <tr>
      <th>amount</th>
      <td>{{action.amount}}</td>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'UserActionInfoAddPending',

  props: {
    action: {
      type: Object,
      required: true,
    }
  },
};
</script>
